module.exports = __webpack_public_path__ + "static/media/money.d393a9a3.svg";